// @flow
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { SP_USER_COMMIT_PAGE_CONFIG } from '@src/components/streaming-projects/user-commit-details/config';
import { useFormikContext } from 'formik';

export const useShouldPricingBeDisabled = () => {
  const { initialValues, values } = useFormikContext();

  return isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    SP_USER_COMMIT_PAGE_CONFIG
  );
};
